import { KnowledgeLayoutOptionContent } from './KnowledgeLayoutOptionContent';
export default KnowledgeLayoutOptionContent;